import { Component } from "vue-property-decorator";
import BaseBlock from "@/blocks/base-block";
import { Block } from '../../../helpers/components';

@Block() @Component
export class ApartmentViewsBlock extends BaseBlock {
	planLocationLoaded: boolean = false;
	viewHouseLoaded: boolean = false;
	floorPlanFloorLoaded: boolean = false;
}

export default ApartmentViewsBlock;
